export default "__VITE_ASSET__cSb7cGAt__"